/* eslint-disable parog-web/no-glint-expect-error-directive */
import Component from '@glimmer/component';
import { type Signature as ProviderSig } from 'parog-web/components/forc/provider';
import BaseAntecedentsFields from '../base-antecedents-fields';

interface Signature {
  Args: {
    form: ProviderSig['Blocks']['content'][0];
  };
}

export default class MyComponent extends Component<Signature> {
  BaseAntecedentsFields = BaseAntecedentsFields;

  <template>
    <this.BaseAntecedentsFields
      @form={{@form}}
      {{! @glint-expect-error }}
      @patient={{@patient}}
    >

      <div class='field'>
        <@form.AlignedFieldsRadioGroup
          @propertyName='lungCancerFamily'
          @title='Famille de cancer pulmonaire familial'
          as |Group|
        >
          <Group.FieldRadio @label='Oui' @value={{true}} />
          <Group.FieldRadio @label='Non' @value={{false}} />
        </@form.AlignedFieldsRadioGroup>
      </div>

      <div class='field'>
        <@form.AlignedFieldsRadioGroup
          @propertyName='chronicBronchopneumopathy'
          @title='Bronchopneumopathie Chronique'
          as |Group|
        >
          <Group.FieldRadio @label='Oui' @value={{true}} />
          <Group.FieldRadio @label='Non' @value={{false}} />
        </@form.AlignedFieldsRadioGroup>
      </div>
    </this.BaseAntecedentsFields>
  </template>
}
